import React from 'react'
import { useForm } from 'react-hook-form';
import { LockClosedIcon,IdentificationIcon } from '@heroicons/react/outline'
import { useMutation } from 'react-query';
import UserService from '../../services/user.services';
import { useAuth } from '../../middleware/auth.middleware';
import { toast } from 'react-toastify';
import { InputUi } from '../../components/input.ui';
import { ButtonUi } from '../../components/components';

export const Login = () => {

  const _useAuth = useAuth();
  const _form = useForm({mode: 'all'});

  //login 
  const _login = useMutation(UserService.login, {
    onSuccess: resp => {
      _useAuth.login(resp.data?.token, resp.data?.user?.typeAccount);
      _form.reset();
    },
    onError: resp => {
      if(resp?.response?.data?.error){
        toast.error(resp?.response?.data?.error)
      } else{
        toast.error("Une erreur inconnue s'est produite")
      }
    }
  })

  const inputParams = [
    {
      label: 'Entrer votre numéro',
      placeholder: '610220302',
      name: 'telephone',
      type: 'text',
      leftIcon: IdentificationIcon,
      error: _form.formState.errors?.telephone?.message,
      validations: {
        required: 'Le téléphone est réquis',
      }
    },
    {
      label: 'Entrer votre mot de passe',
      placeholder: '*********',
      name: 'password',
      type: 'password',
      autoComplete: "current-password",
      leftIcon: LockClosedIcon,
      error: _form.formState.errors?.password?.message,
      validations: {
        required: 'Mot de passe est réquis',
        maxLength: { value: 20, message: 'Au maximum 20 caractères' },
        minLength: { value: 6, message: 'Au minimum 6 caractères' },
      }
    },
  ]

  const onSubmit = (r) => {
    _login.reset()
    _login.mutate({telephone: r.telephone, password: r.password})
  }

  return (
    <>
      <div className="w-80 rounded-md shadow-md p-2 mx-10 flex flex-col items-center m-5 ">
          <img
            className="mx-auto h-24 w-auto"
            src="/assets/logo3.png"
            alt="Workflow"
          />
          <h2 className="mt-6 text-center text-xl font-bold text-gray-900">Plateforme de Gestion de la Cantine et de la salle de GYM</h2>
          
        <form className="space-y-6 pt-10" onSubmit={_form.handleSubmit(onSubmit)}>
          {
            inputParams?.map(item => (
              <div key={item.name}>
                <InputUi
                  label={item.label}
                  name={item.name}
                  type={item.type}
                  LeftIcon={item.leftIcon}
                  placeholder={item.placeholder}
                  register={_form.register}
                  error={item.error}
                  validations={item.validations}
                  bg='gray-200'
                  />
              </div>
            ))
          }

          <div>
            <ButtonUi isLoading={_login.isLoading}>{'Se connecter'}</ButtonUi>
            
          </div>
        </form>
      </div>
    </>
  )
}

